import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IAvtSettings } from 'legacy/lut/classes/models/partner360/ELT/IAvtSettings'

import { IBaseModel } from 'core/types/interface/BaseModel'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const FORM_ID = 1233
export const FORM_CODE = 'executive-leadership-team-1233'

export interface IELTDataSettings extends Omit<IAvtSettings, 'AVTDefault' | 'ActualsValueTypes'> {
  NetNdp?: ActualsValueTypes
  ActualsValueTypes: ActualsValueTypes[]
}

export interface IELTData extends IBaseModel {
  RTReady?: number
  FYear: number
  FQuarter: number
  LastStep: number
  Logo: string
  PPTXReport: string
  PartnerId: string | null
  PartnerName: string
  GroupId: number | null
  Picture: string
  FormData: string
  GuidelinesWasRead: number
  GuidesStep: number
  FormModified: string
  FormModifiedBy: string
  Version: number
  VersionName: string
  ClonedFromVersion: number
  Finalized: number
  GroupMembers: string
  Settings: string
  EltType: EltType
  Attachment: string
  UID: string
}
